const UserStateActions = {
  setAuth: "setAuth",
  setUser: "setUser",
  deleteAuth: "deleteAuth",
  deleteUser: "deleteUser"
};

const UserState = {
  state: {
    user: null,
    token: null
  },
  mutations: {
    setAuth(state, token) {
      state.token = token;
    },
    setUser(state, user) {
      state.user = user;
    },
    deleteAuth(state) {
      state.token = null;
    },
    deleteUser(state) {
      state.user = null;
    }
  },
  actions: {
    setAuth(context, token) {
      sessionStorage.setItem("asd-token", token);
      context.commit("setAuth", token);
    },
    setUser(context, user) {
      const data = JSON.stringify(user)
      sessionStorage.setItem("user", data);
      context.commit("setUser", data);
    },
    deleteAuth(context) {
      sessionStorage.removeItem("asd-token");
      context.commit("deleteAuth");
    },
    deleteUser(context) {
      sessionStorage.removeItem("user");
      context.commit("deleteUser");
    }
  }
}

export {
  UserState,
  UserStateActions
};